import React from 'react';
import { Form, InputNumber } from 'antd';

const EngineValume = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <div className="sizeEngineArea">
      <span className="label">Объем двигателя, см :</span>
      <Form.Item>
        {getFieldDecorator('engineVolume')(
          <InputNumber
            className="smallInput"
            min={500}
            max={14000}
            maxLength={5}
            placeholder="Укажите"
            disabled={disabled}
          />
        )}
      </Form.Item>
    </div>
  );
};

export default EngineValume;
